import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import UseOrgDefaultClassificationLevelIdQuery, {
	type useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery$data,
	type useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery$variables,
} from '../hooks/__generated__/useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery.graphql';

export function preloadOrgDefaultClassificationLevelIdQuery() {
	return query<
		useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery$data,
		useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery$variables
	>({
		query: UseOrgDefaultClassificationLevelIdQuery,
	});
}
